import { render, staticRenderFns } from "./content2.vue?vue&type=template&id=1b54648b&scoped=true"
import script from "./content2.vue?vue&type=script&lang=js"
export * from "./content2.vue?vue&type=script&lang=js"
import style0 from "./content2.vue?vue&type=style&index=0&id=1b54648b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b54648b",
  null
  
)

export default component.exports